module.exports = __webpack_public_path__ + "img/balance_bg.f4664057.png";